'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var fieldErrorsShape = _react.PropTypes.shape({
  classification: _react.PropTypes.string,
  message: _react.PropTypes.string,
  id: _react.PropTypes.string,
  values: _react.PropTypes.object
});

exports.default = fieldErrorsShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/bc-prop-types/lib/components/fieldErrorsShape.js
// module id = 370
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16